import React from 'react';
import i18next from 'i18next';
import { useStats, useSearchBox, useSortBy } from 'react-instantsearch';
import {
  SearchBar as DefaultSearchBar,
} from '@uncinc/react-searchkit';

const SearchBar = ({ defaultSorting, relevanceSorting, typeMembers = false }) => {
  const { query } = useStats();
  const { clear } = useSearchBox();
  const { refine, currentRefinement } = useSortBy({
    items: [
      { value: defaultSorting },
      { value: relevanceSorting },
    ],
  });

  return (
    <div className="SearchBar">
      <DefaultSearchBar
        searchAsYouType
        buttonText={<span>{i18next.t('components.search.search')}</span>}
        placeholder={i18next.t(`components.search.searchbar.${typeMembers ? 'placeholder_members' : 'placeholder'}`)}
        onSubmit={(query) => {
          // If we have a query then make sure the relevance sorting is activated.
          if (query && currentRefinement !== relevanceSorting) {
            refine(relevanceSorting);
          }
          // If our query is empty make sure the default sorting is activated.
          if (!query && currentRefinement !== defaultSorting) {
            refine(defaultSorting);
          }
        }}
      />
      {query && (
        <div className="PageHeader__content__searchbar__icon" onClick={() => clear()}>
          <i className="icon icon-cross icon-variant-0" />
        </div>
      )}
    </div>
  );
};

export default SearchBar;
